import React from "react";
import { ReactComponent as AntecnaLogo } from "./images/antecna-full-logo.svg";

const Logo = (props) => <AntecnaLogo {...props}></AntecnaLogo>;

export default Logo;
